import GlobalUserListViewModel from "../view/globaluserlistviewmodel";
import PagedElements from "./pagedelements";

export default class PagedGlobalUsers extends PagedElements<GlobalUserListViewModel> {
    constructor(init?: Partial<PagedGlobalUsers>) { super(init); }
}